import api, { publicApi } from 'services/api';
import { IAuthData, UserResponce } from 'types';
import { Dispatch } from 'redux';
import { ACCESS_TOKEN } from 'utils/storageKeys';
import Logger from 'components/common/helpers/devConsoleLog';
import MobileService from 'services/mobile';
import { AxiosResponse } from 'axios';
import {
  USER_LOGIN,
  USER_LOGOUT,
  USER_LOGIN_ERROR,
  USER_SIGNUP,
  USER_SIGNUP_ERROR,
  SET_ROOT_LINK,
} from './actionTypes';
import { addUserDataToTrackingSession } from '../services/tracking-session';
import { setUserInSentry } from '../utils/helpers/sentry';

export type ResetPswData = {
  email: string;
  code: string;
  newPassword?: string;
};

export const clearAuthErrors = (type: string) => (dispatch: Dispatch): void => {
  if (type === 'login') {
    dispatch({
      type: USER_LOGIN_ERROR,
      payload: {},
    });
  } else {
    dispatch({
      type: USER_SIGNUP_ERROR,
      payload: {},
    });
  }
};

export const userSignUp = (data: IAuthData) => async (
  dispatch: Dispatch
): Promise<void> => {
  try {
    const res: AxiosResponse<Required<UserResponce>> = await publicApi.post(
      '/auth/register',
      data
    );
    dispatch({
      type: USER_SIGNUP,
      payload: res.data,
    });
    dispatch({
      type: SET_ROOT_LINK,
      payload: '/registration-success',
    });

    addUserDataToTrackingSession({ userId: res.data.user.id });
    setUserInSentry(res.data.user);
    localStorage.setItem(ACCESS_TOKEN, res.data.accessToken);
    // A.Starusiev TODO general error DTO
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    dispatch({
      type: USER_SIGNUP_ERROR,
      payload: { message: error?.response?.data?.message },
    });
    Logger('userSignUp error:', error?.response?.data?.message);
  }
};

export const changeRootLink = (link: string) => async (
  dispatch: Dispatch
): Promise<void> => {
  dispatch({
    type: SET_ROOT_LINK,
    payload: link,
  });
};

export const userLogin = (data: IAuthData) => async (
  dispatch: Dispatch
): Promise<void> => {
  try {
    const res: AxiosResponse<Required<UserResponce>> = await publicApi.post(
      '/auth/signin',
      data
    );
    dispatch({
      type: USER_LOGIN,
      payload: res.data,
    });

    addUserDataToTrackingSession({ userId: res.data.user.id });
    setUserInSentry(res.data.user);
    localStorage.setItem(ACCESS_TOKEN, res.data.accessToken);
    // A.Starusiev TODO general error DTO
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    dispatch({
      type: USER_LOGIN_ERROR,
      payload: { message: error?.response?.data?.message },
    });
    Logger('userSignUp error:', error);
  }
};

export const sendResetPasswordCode = (
  email: string
) => async (): Promise<void> => {
  try {
    await publicApi.post('/auth/password', { email });
  } catch (error) {
    Logger('sendResetPasswordCode error:', error);
  }
};

export const resetPassword = (
  data: ResetPswData
) => async (): Promise<void> => {
  try {
    await publicApi.put('/auth/password', data);
  } catch (error) {
    Logger('resetPassword error:', error);
  }
};

async function deleteDeviceToken() {
  try {
    const token = await MobileService.getToken();

    if (token) {
      await api.delete('/push-notification/device', { data: { token } });
    }
  } catch (error) {
    Logger('deleteDeviceToken error:', error);
  }
}

export const logOut = () => async (dispatch: Dispatch): Promise<void> => {
  try {
    await deleteDeviceToken();

    localStorage.clear();
    dispatch({
      type: USER_LOGOUT,
    });
  } catch (error) {
    Logger('logOut error:', error);
  }
};
